<template>
  <div>
    <h2>{{ $t('device_manage') }}</h2>
    <div class="device-management-h5">
      <div class="management-title">{{$tc('title', 0)}} {{user.max_device_count}} {{user.max_device_count > 1 ? $tc('title', 2) : $tc('title', 1)}}</div>
      <div class="new-tips">*{{$t('new_tips')}}</div>
      <div class="no-record" v-show="hasFetch && records.length === 0">{{$t('no_data')}}</div>
      <div id="records-list" v-if="records.length > 0">
        <div class="phone-records-row" v-for="(item, index) in records" :key='item.id'>
          <div class="platform">
            <img :src="'/static/img/dashboard/ic_'+item.device_platform+'.svg'">
            <span>{{$t('device')}} {{index + 1}}{{currentLang === 'en' ? ': ' : '：'}}</span>
            <span class="text-wrapper">{{item.name}}</span>
          </div>
          <div class="delete">
            <span @click="$emit('showModifyModal', item.id, item.name)" class="modify-btn"></span>
            <span @click="$emit('showDeleteModal', item.id)" class="delete-btn">{{$t('delete_btn')}}</span>
          </div>
        </div>
      </div>

    </div>
    <router-link tag="div" to="/dashboard" class="add-device-num">{{$t('add_device')}}</router-link>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import locales from './lang'

  export default {
    name: 'device-management-h5',
    props: ['initData', 'hasFetch'],
    locales,
    data: function () {
      return {
        records: []
      }
    },
    computed: {
      ...mapState({
        user: 'user',
        currentLang: 'currentLang'
      })
    },
    watch: {
      initData() {
        this.records = this.initData.body.data
      }
    }
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  * {
    padding: 0;
    margin: 0;
  }

  h2 {
    display: block;
    font-size: .24rem;
    line-height: 32px;
    color: #111111;
    font-weight: 600;
    text-align: center;
    margin-bottom: 0.24rem;
  }

  .device-management-h5 {
    border: 1px solid #E0D7E3;
    border-radius: .05rem;
    // min-height: calc(100vh - .6rem - .4rem - 1.2rem);
    .no-record {
      margin: 0.4rem auto;
      text-align: center;
      color: #666;
      font-size: 0.12rem;
      line-height: .18rem;
    }
    .management-title {
      padding: .15rem .16rem .05rem;
      font-size: .14rem;
      line-height: .2rem;
      color: #111;
      letter-spacing: 0;
      border-radius: 0;
    }
    .new-tips {
      padding: 0 .16rem .15rem;
      border-bottom: 1px solid #E0D7E3;
      font-size: 0.11rem;
      line-height: .16rem;
      color: #666;
    }
  }

  #records-list {
    padding: 24px 16px;
  }

  .phone-records-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-radius: 0;
    &:nth-child(n+2) {
      margin-top: 24px;
    }
    .platform {
      line-height: 16px;
      letter-spacing: 0;
      display: flex;
      align-items: center;
      img {
        width: 16px;
        margin: -4px 5px 0 0;
      }
      span {
        font-size: 12px;
        display: inline-block;
        color: #666;
      }
      .text-wrapper {
        white-space: pre-wrap;
        margin-left: 2px;
      }
    }
    .delete {
      color: #F76B4C;
      text-align: right;
      span.delete-btn {
        cursor: pointer;
        display: inline-block;
        width: 85px;
        height: 22px;
        font-size: 12px;
        line-height: 20px;
        letter-spacing: 0;
        text-align: center;
        border: 1px solid #F76B4C;
        border-radius: 13px;
      }
      span.modify-btn {
        cursor: pointer;
        width: 16px;
        height: 16px;
        margin-right: 10px;
        display: inline-block;
        vertical-align: middle;
        background: url('/static/img/dashboard/ic_modify.svg') center / 16px no-repeat;
      }
    }
  }

  .add-device-num {
    width: 80%;
    height: .49rem;
    line-height: .49rem;
    font-size: .16rem;
    color: #416CF8;
    text-align: center;
    border: 1px solid #416CF8;
    font-weight: 600;
    border-radius: 100px;
    margin: .24rem auto 0;
  }

  .spinner-box {
    min-height: .6rem;
  }
</style>



// WEBPACK FOOTER //
// DeviceManagementM.vue?168e5ab6